import APIClient from '@/shared/http/clients/api'

const resourceName = 'REProposta'
const APIBaseURLRealEstate = process.env.APIBaseURLRealEstate

const GetAll = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}`, data, config)
const Search = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetAllRelatorio`, data, config)
const GetAllNomeEPRoposta = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/solicitacoes`, data, config)
const GetAllRelatorio = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetAllRelatorio`, data, config)
const GetRelatorioAnual = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetRelatorioAnual`, data, config)
const GetRelatorioAnualCredenciada = (data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetRelatorioAnualCredenciada`, data, config)
const getAllCredenciadaSearchrela = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/getAllCredenciadaSearchrela`, data, config)
const GetRelatorioCorretor = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetRelatorioCorretor`, data, config)
const GetRelatorioCredenciada = (data = {}, config = {}) => APIClient.post(`${APIBaseURLRealEstate}/${resourceName}/GetRelatorioCredenciada`, data, config)
const GetCredenciadaByNameProposta = (name, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetCredenciadaByNameProposta/${name}`, data, config)
const GetCorretorByNameSalesReports = (name, data = {}, config = {}) => APIClient.get(`${APIBaseURLRealEstate}/${resourceName}/GetCorretorByNameSalesReports/${name}`, data, config)
const SetCancelar = (id, data = {}, config = {}) => APIClient.put(`${APIBaseURLRealEstate}/${resourceName}/SetCancelar/${id}`, data, config)

const ProposalRepository = {
  GetAll,
  Search,
  GetAllNomeEPRoposta,
  GetAllRelatorio,
  GetRelatorioAnualCredenciada,
  getAllCredenciadaSearchrela,
  GetRelatorioAnual,
  GetRelatorioCorretor,
  GetRelatorioCredenciada,
  GetCredenciadaByNameProposta,
  GetCorretorByNameSalesReports,
  SetCancelar

}

export default ProposalRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/realestate/proposal.js